import { accordion_children } from "dependencies/accordion/index.js"
let icon = "icon-portal-accordion"
export default {
  name: "手风琴图文",
  id: "",
  thumbnail: icon,
  type: "cxSystemAccordion",
  componentType:"emptyLayoutComponent",
  // typeId: "814e697a52ab9111ee0b3433893689d22708",
  typeId: "",
  children: []
}
